import useOffersLoader from "../common/useOffersLoader";
import useBeginCheckoutEvent from "./useBeginCheckoutEvent";
import useLoadPackageSizes from "./useLoadPackageSizes";

const useSummarySideEffects = (): void => {
  useLoadPackageSizes();
  useOffersLoader();
  useBeginCheckoutEvent();
};
export default useSummarySideEffects;
